"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const sortablejs_1 = __importDefault(require("sortablejs"));
require("./style.less");
const initHandler = (element, valueAccessor, allBindings, viewModel, bindingContext) => {
    const config = valueAccessor();
    const { foreach, options } = config || {};
    const { onAdd, onUpdate, onRemove, onChange, onEnd, onSort, beforeMoved, comparer, ...fields } = options || {};
    element.__fb_sortable_value = foreach;
    function getList(el) {
        const container = el;
        return container.__fb_sortable_value;
    }
    const params = {
        forceFallback: true,
        fallbackClass: "fb-sortable-clone",
        ghostClass: "fb-sortable-ghost",
        chosenClass: "fb-sortable-chosen",
        dragClass: "fb-sortable-drag",
        onClone: (event) => {
            event.clone.style.height = "";
        },
        onAdd: (event) => {
            // добавление в текущий список
            if (ko.isWriteableObservable(foreach)) {
                const { newIndex, oldIndex, from, item } = event;
                const sourceValue = getList(from);
                if (ko.isObservable(sourceValue)) {
                    const movedElement = ko.unwrap(sourceValue)[oldIndex];
                    const oldValue = foreach();
                    const newValue = [...oldValue];
                    newValue.splice(newIndex, 0, movedElement);
                    if (typeof comparer === "function") {
                        newValue.sort(comparer);
                        foreach([]); // TODO: hack, иначе не обновляется UI
                    }
                    item.remove();
                    foreach(newValue);
                }
            }
            setTimeout(() => {
                if (typeof onAdd === "function")
                    onAdd(event);
            });
        },
        onRemove: (event) => {
            // удаление из текущего списка
            if (ko.isWriteableObservable(foreach)) {
                const { oldIndex } = event;
                const oldValue = foreach();
                const newValue = [...oldValue];
                newValue.splice(oldIndex, 1);
                foreach(newValue);
            }
            if (typeof onRemove === "function")
                setTimeout(() => onRemove(event));
        },
        onUpdate: (event) => {
            // перемещение в пределах текущего списка
            if (ko.isWriteableObservable(foreach)) {
                const { oldIndex, newIndex } = event;
                const oldValue = foreach();
                const newValue = [...oldValue];
                const movedElement = newValue[oldIndex];
                newValue.splice(oldIndex, 1);
                newValue.splice(newIndex, 0, movedElement);
                console.log({ newValue, comparer });
                if (typeof comparer === "function") {
                    newValue.sort(comparer);
                    foreach([]); // TODO: hack, иначе не обновляется UI
                }
                foreach(newValue);
            }
            if (typeof onUpdate === "function")
                setTimeout(() => onUpdate(event));
        },
        onEnd: (event) => {
            setTimeout(() => {
                if (typeof onEnd === "function") {
                    onEnd(event);
                }
            });
        },
        onSort: (event) => {
            // элемент перемещен
            console.log("on sort", onEnd);
            if (typeof onSort === "function")
                setTimeout(() => onSort(event));
        },
        onChange: (event) => {
            // элемент в процессе перемещения, меняет положение
            if (typeof onChange === "function")
                onChange(event);
        },
        onMove: (event, originalEvent) => {
            // вызывается постоянно в процессе перемещения, можно отменить
            if (typeof beforeMoved === "function") {
                const res = beforeMoved(event, originalEvent);
                if (res) {
                    const { enabled, message } = res;
                    if (enabled) {
                        event.dragged.classList.remove("fb-sortable-disabled");
                        event.dragged.dataset.sortableMessage = "";
                    }
                    else {
                        event.dragged.classList.add("fb-sortable-disabled");
                        if (message)
                            event.dragged.dataset.sortableMessage = message;
                    }
                    return enabled;
                }
            }
        },
        ...fields,
    };
    console.log({ options, onEnd, params });
    const model = sortablejs_1.default.create(element, params);
    element.__fb_sortable = model;
    ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
        model.destroy();
    });
    return ko.bindingHandlers.template.init(element, valueAccessor, allBindings, viewModel, bindingContext);
};
const updateHandler = (element, valueAccessor, allBindings, viewModel, bindingContext) => {
    return ko.bindingHandlers.template.update(element, valueAccessor, allBindings, viewModel, bindingContext);
};
const binding = {
    init: initHandler,
    update: updateHandler,
};
exports.default = binding;
